module.exports = __webpack_public_path__ + "static/media/photo98.502f38cc.jpg";